import React, { Component, useEffect, useState } from "react";
import {
  Icon,
  Row,
  Col,
  Card,
  Modal,
  Select,
  Radio,
  Button,
  Spin,
  DatePicker,
  Checkbox,
  Input,
  message,
} from "antd";
import {
  GET_RS_USERS_API,
  GET_FS_ALL_AGENCIES,
  TRANSFER__BFILES_API_V4,
  GET_RFS_ALL_AGENCIES,
  GET_RFS_ASSIGNED_AGENCIES_BY_ROLES,
  GET_RFS_USERS_AND_AGENCIES_BY_ROLES,
  TRANSFER_RFS_BFILES
} from "../../../utils/Api_enums";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import F from "../../../Functions";
import { useBoundStore } from "../../../store/useBoundStore";
import { API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API, GET_ROLES_API, TRANSFER__BFILES_API_V3, TRANSFER_BFILES_API, VONBOARDERS_USERS_LIST_API_URL } from "../../../utils/Api_enums";
import { ALL, FOLLOWUP, LEAD, OPPORTUNITY, PLEASE_FILL_ALL_REQUIRED_FIELD, PROSPECT, REVIEW, SELECT_FOLLOW_UP_SPECIALIST, SELECT_SCHEDULER, TYPE_OF_CALL, VONBOARDER, VONSCHEDULER } from "../../../utils/Constants";
import AgencyBadge from "../../../Custom-Tooltip/AgencyBadge";

const { TextArea } = Input;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const NewUnlinkModal = (props) => {
  const user_type = props.user.user_type;
  const user_id = props.user.id;
  // console.log("modal props ---->", props);

  const { userType } = useBoundStore((state) => ({
    userType: state.userType,
  }));

  const [unlinkModalState, setUnlinkModalState] = useState({
    loading: true,
    users: [],
    agent: "",
  });
  const [roles, setRoles] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [fsAgencies, setFSAgencies] = useState([]);

  const [isAllSelected, setIsAllSelected] = useState(false);
  const [agency_ids, setAgencyIds] = useState(props.user_agencies || []);
  const [agency_type_map, set_agency_type_map] = useState(props.agency_type_map || []);
  const [checkedAgencyIds, setcheckedAgencyIds] = useState([]);
  const rowRoles = props && props.rowData &&
    props.rowData.type_of_Call && props.rowData.type_of_Call.split(",");

  useEffect(() => {
    let userRoles;

    if (props && props.rowData && props.rowData.user_roles) {
      userRoles = props.rowData.user_roles || [];
    }

    const hasFollowup = userRoles.some(r => r.rolename === FOLLOWUP);
    const hasProspect = userRoles.some(r => r.rolename === PROSPECT);

    let defaultSelected = null;

    if (user_type === VONBOARDER) {
      if (hasProspect) {
        defaultSelected = PROSPECT;
      } else if (hasFollowup) {
        defaultSelected = FOLLOWUP;
      }
    }

    let updatedRoles = userRoles
      .map(item => {
        let isChecked = true;
        if (user_type === VONSCHEDULER) {
          isChecked = item.rolename === REVIEW;
        } else if (user_type === VONBOARDER) {
          isChecked = item.rolename === defaultSelected;
        }

        return {
          label: TYPE_OF_CALL[item.rolename],
          value: TYPE_OF_CALL[item.rolename],
          role_id: item.role_id,
          checked: isChecked,
        };
      })
      .filter(r => rowRoles.includes(r.label));


    const sortedRoles = updatedRoles.sort((a, b) => b.role_id - a.role_id)
    setRoles(sortedRoles);
    if (user_type == VONBOARDER) {
      getAllAgenciesList(agency_type_map, defaultSelected);
    }
  }, []);



  const getAllAgenciesList = (agency_type_map, defaultSelected) => {

    let agencyIds;

    if (defaultSelected == PROSPECT) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.Prospect === true)
        .map(([id]) => Number(id));

    } else if (defaultSelected == FOLLOWUP) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.FollowUp === true)
        .map(([id]) => Number(id));

    } else if (defaultSelected == REVIEW) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.Review === true)
        .map(([id]) => Number(id));
    }



    let url = GET_FS_ALL_AGENCIES;
    axios
      .get(url)
      .then((res) => {
        const responseData = res.data;
        setFSAgencies(responseData);

        const filteredData = responseData.filter((a) => agencyIds.includes(a.id))
        setAgencies(filteredData);
      })
      .catch((err) => {
        console.error("Error fetching agencies:", err);
      });
  }


  const getFSAgenciesList = (agency_type_map, defaultSelected) => {
    let agencyIds;

    if (defaultSelected == PROSPECT) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.Prospect === true)
        .map(([id]) => Number(id));

    } else if (defaultSelected == FOLLOWUP) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.FollowUp === true)
        .map(([id]) => Number(id));

    } else if (defaultSelected == REVIEW) {
      agencyIds = Object.entries(agency_type_map)
        .filter(([id, val]) => val.Review === true)
        .map(([id]) => Number(id));
    }
    const filteredData = fsAgencies.filter((a) => agencyIds.includes(a.id))
    setAgencies(filteredData);
  }

  useEffect(() => {
    const loadUsers = async (queryparam, isReviewChecked, isOpportunityChecked, isLeadChecked) => {
      let api = "";

      if (user_type == VONSCHEDULER) {
        let reivew = isReviewChecked ? 1 : 0;
        let prospect = isLeadChecked ? 1 : 0;
        let followUp = isOpportunityChecked ? 1 : 0;
        api = `${GET_RFS_USERS_AND_AGENCIES_BY_ROLES(user_id, String(reivew),
          String(followUp), String(prospect))}`;
      } else if (user_type == VONBOARDER) {
        api = `${VONBOARDERS_USERS_LIST_API_URL}?rolename_param=${queryparam}`;
      }

      try {
        const res = await axios.get(api);

        let usersList = [];

        if (user_type === VONBOARDER) {
          if (Array.isArray(res.data["Virtual On-Boarding1"])) {
            usersList = res.data["Virtual On-Boarding1"].filter(
              (user) => user.id !== user_id
            );
          }
        } else {
          usersList = Array.isArray(res.data.schedulers) ? res.data.schedulers : [];
          const responseData = res.data.agencies;
          const filteredData = responseData.filter((a) => agency_ids.includes(a.id))
          setAgencies(filteredData);
        }

        setUnlinkModalState((prev) => ({
          ...prev,
          users: usersList,
          agent: "",
        }));
      } catch (err) {
        console.log("API error:", err);
      } finally {
        setUnlinkModalState((prev) => ({
          ...prev,
          loading: false,
        }));
      }
    };


    const isLeadChecked = roles.some(r => r.label === LEAD && r.checked);
    const isOpportunityChecked = roles.some(r => r.label === OPPORTUNITY && r.checked);
    const isReviewChecked = roles.some(r => r.label === REVIEW && r.checked);

    if (user_type == VONBOARDER) {
      if (isLeadChecked && isOpportunityChecked) {
        loadUsers("both");
      } else if (isLeadChecked) {
        loadUsers(PROSPECT);
      } else if (isOpportunityChecked) {
        loadUsers(FOLLOWUP);
      } else {
        setUnlinkModalState((prev) => ({
          ...prev,
          users: [],
          agent: "",
        }));
      }
    } else {
      loadUsers("both", isReviewChecked, isOpportunityChecked, isLeadChecked);
    }

  }, [roles]);


  const getRolesCheckFunc = () => {
    if (roles.filter(role => role.checked === true).length === 2) {
      return ALL;
    } else {
      const checkedRoles = roles.filter(role => role.checked === true);
      if (checkedRoles[0].label === LEAD) {
        return PROSPECT
      }
      if (checkedRoles[0].label === OPPORTUNITY) {
        return FOLLOWUP
      }
    }
  }

  const save = async () => {
    const { agent } = unlinkModalState;
    const { user } = props;

    setUnlinkModalState((prev) => ({ ...prev, loading: true }));

    if (!agent) {
      message.error(PLEASE_FILL_ALL_REQUIRED_FIELD);
      setUnlinkModalState((prev) => ({ ...prev, loading: false }));
      return;
    }


    const isLeadChecked = roles.some(r => r.label === LEAD && r.checked);
    const isOpportunityChecked = roles.some(r => r.label === OPPORTUNITY && r.checked);
    const isReviewChecked = roles.some(r => r.label === REVIEW && r.checked);

    let api = "";


    // if (user_type === VONBOARDER) {
    //   const leadFlag = isLeadChecked ? 1 : 0;
    //   const opportunityFlag = isOpportunityChecked ? 1 : 0;
    //   if ((isLeadChecked || isOpportunityChecked) &&
    //     !(isLeadChecked && isOpportunityChecked)) {
    //     api = `${TRANSFER__BFILES_API_V4}&role_filter=${getRolesCheckFunc()}&lead=${leadFlag}&opportunity=${opportunityFlag}`;
    //   } else {
    //     let res = await axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API}/${user.id}`);
    //     if (res.data && res.data.success && res.data.unclick === false) {
    //       api = `${TRANSFER__BFILES_API_V4}&lead=${leadFlag}&opportunity=${opportunityFlag}`;
    //     } else {
    //       api = `${TRANSFER__BFILES_API_V4}&role_filter=${getRolesCheckFunc()}&lead=${leadFlag}&opportunity=${opportunityFlag}`;
    //     }
    //   }
    // }


    if (user_type === VONBOARDER) {
      const leadFlag = isLeadChecked ? 1 : 0;
      const opportunityFlag = isOpportunityChecked ? 1 : 0;

      api = `${TRANSFER__BFILES_API_V4}&role_filter=${getRolesCheckFunc()}&lead=${leadFlag}&opportunity=${opportunityFlag}`;
    }



    if (user_type === VONSCHEDULER) {

      const review = isReviewChecked ? 1 : 0;
      const followUp = isOpportunityChecked ? 1 : 0;
      const prospect = isLeadChecked ? 1 : 0;


      let role_filter = "all";

      if (isReviewChecked && isLeadChecked && isOpportunityChecked) {
        role_filter = "Review&Prospect&FollowUp";
      } else if (isReviewChecked && isLeadChecked) {
        role_filter = "Review&Prospect";
      } else if (isReviewChecked && isOpportunityChecked) {
        role_filter = "Review&FollowUp";
      } else if (isLeadChecked && isOpportunityChecked) {
        role_filter = "FollowUp&Prospect";
      } else if (isReviewChecked) {
        role_filter = "Review";
      } else if (isLeadChecked) {
        role_filter = "Prospect";
      } else if (isOpportunityChecked) {
        role_filter = "FollowUp";
      }


      api = TRANSFER_RFS_BFILES(review, followUp, prospect, role_filter);
    }


    try {
      const res = await axios.post(api, {
        user_id: user.id,
        new_user_id: agent,
        isAllSelected: isAllSelected,
        agency_ids: checkedAgencyIds || []
      });

      if (res.data.success) {
        message.success(F.translate(res.data.results || ""));
        props.hideModal();
        props.refresh();
      } else {
        message.error("Cannot unlink the user.");
      }

    } catch (err) {
      console.log("save error", err);
      message.error("Something went wrong");
    }

    setUnlinkModalState((prev) => ({ ...prev, loading: false }));
  };


  const checkboxhandleChange = (selectedRole) => {

    if (user_type == VONBOARDER) {
      const roleSelected =
        selectedRole.value == OPPORTUNITY
          ? FOLLOWUP
          : selectedRole.value == LEAD
            ? PROSPECT
            : null;
      getFSAgenciesList(agency_type_map, roleSelected)
    }


    if (user_type === VONSCHEDULER || user_type == VONBOARDER) {
      const updatedRoles = roles.map((role) => ({
        ...role,
        checked: role.role_id === selectedRole.role_id
      }));

      setRoles(updatedRoles);
      return;
    }


    // const updatedCheckBoxRoles = roles.map((role) => {
    //   if (role.role_id === selectedRole.role_id) {
    //     return {
    //       ...role,
    //       checked: !role.checked,
    //     };
    //   }
    //   return role;
    // });

    // setRoles(updatedCheckBoxRoles);
  };


  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsAllSelected(checked);
    if (checked) {
      setcheckedAgencyIds(agencies.map(a => a.id));
    } else {
      setcheckedAgencyIds([]);
    }
  };



  const handleCheckboxChange = (e, id) => {
    const checked = e.target.checked;

    let updated = [];
    if (checked) {
      updated = [...checkedAgencyIds, id];
    } else {
      updated = checkedAgencyIds.filter(x => x !== id);
    }
    setcheckedAgencyIds(updated);
    setIsAllSelected(updated.length === agencies.length);
  };


  return (
    <Modal
      title={<Translate text={"Transfer Ownership"} />}
      visible={props.showModal}
      onCancel={() => {
        props.hideModal();
      }}
      footer={
        agencies.length == 0 ? null : (
          <div>
            <Button type="primary"
              className="borderRadius-28 bg-164897"
              loading={unlinkModalState.loading}
              // when both checkbox lead and opportunity are unchecked make the btn disabled 
              disabled={
                roles.length == 2 &&
                roles.filter(role => role.checked === false).length === 2
              }
              onClick={() => save()}>
              <Translate text={`Transfer Ownership`} />
            </Button>
            <Button
              className="borderRadius-28"
              onClick={() => {
                props.hideModal();
                setUnlinkModalState((prevState) => ({
                  ...prevState,
                  loading: false,
                  agent: "",
                }));
              }}
            >
              <Translate text={`Cancel`} />
            </Button>
          </div>
        )
      }
    >
      <Spin indicator={antIcon} spinning={unlinkModalState.loading}>
        {
          // agencies.length == 0 ? (
          //   <label>
          //     <b>
          //       <Translate
          //         text={"No associated agency was found to transfer ownership."}
          //       />
          //     </b>
          //   </label>
          // ) :

          (
            <div className="formBox">
              <div className="mb-10">
                {/* <label style={{ fontWeight: 600 }}>
                  {
                    (rowRoles.includes("Lead") || rowRoles.includes("Opportunity")) && (
                      <Translate text={"Choose Call Type to Transfer "} />
                    )
                  }
                </label> */}
                {/* Showung checkbox on VONBOARDER */}
                {/* {user_type == VONBOARDER && (rowRoles.includes("Lead") || rowRoles.includes("Opportunity")) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "290px",
                    }}
                  >
                    {roles.map((role) => {
                      return (
                        <Checkbox
                          key={role.role_id}
                          value={JSON.stringify(role)}
                          checked={role.checked}
                          onChange={() => checkboxhandleChange(role)}
                          style={{ display: "inline-block" }}
                        >
                          {role.label}
                        </Checkbox>
                      );
                    })}
                  </div>
                )} */}
                <b>
                  <Translate
                    // style={{ fontWeight: 600 }}
                    text={"Choose Call Type to Transfer "} />
                  <span className="asteriskIcon"> *</span>
                </b>
                {/* Showung radiobutton VONSCHEDULER */}
                {(user_type === VONSCHEDULER || user_type == VONBOARDER) && (

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "290px",
                    }}
                  >

                    {roles.map((role) => (
                      <Radio
                        name="schedulerRole"
                        key={role.role_id}
                        value={JSON.stringify(role)}
                        checked={role.checked}
                        onChange={() => checkboxhandleChange(role)}
                        style={{ display: "inline-block" }}
                      >
                        {role.label}
                      </Radio>
                    ))}
                  </div>)}



              </div>
              <div style={{ marginBottom: 25, marginTop: 25 }}>
                {agencies.length == 0 ? (
                  <label>
                    <b>
                      <Translate
                        text={"No associated agency was found to transfer ownership."}
                      />
                    </b>
                  </label>
                ) : (
                  <div>
                    <label>
                      <b>
                        <Translate text={"Select Agency to Transfer"} />
                        <span className="asteriskIcon"> *</span>
                        :
                      </b>
                    </label>
                    <Checkbox
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    >
                      Select All
                    </Checkbox>
                    {agencies.map((agency, i) => (
                      <label key={i}>
                        <Checkbox
                          type="checkbox"
                          checked={checkedAgencyIds.includes(agency.id)}
                          onChange={(e) => handleCheckboxChange(e, agency.id)}
                        >
                          <span>
                            {agency.name}
                            <AgencyBadge
                              showTest={agency.test == 1}
                              showInactive={agency.active == 0}
                            />
                          </span>

                        </Checkbox>
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontWeight: 600 }}>
                  <Translate
                    text={"Who do you want to transfer the ownership to?"}
                  />
                  <span className="asteriskIcon"> *</span>
                </label>
                <Select
                  defaultValue={""}
                  showSearch
                  optionFilterProp="children"
                  value={unlinkModalState.agent}
                  style={{ width: "100%" }}
                  onChange={(val) => {
                    setUnlinkModalState((prevState) => ({
                      ...prevState,
                      agent: val,
                    }));
                  }}
                >
                  <Option value={""}>
                    <Translate text={`${user_type == VONSCHEDULER ?
                      SELECT_SCHEDULER : SELECT_FOLLOW_UP_SPECIALIST
                      }`} />
                  </Option>
                  {unlinkModalState.users.map((user, i) => (
                    <Option key={i} value={user.id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          )
        }
      </Spin>
    </Modal>
  );
};

export default NewUnlinkModal;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/parts/NewUnlinkModal.js